export const PATIENT_NAME_OPTIONS = {
  FullName: "Patient.FullName",
  FirstName: "Patient.FirstName",
  LastName: "Patient.LastName",
  MiddleInitial: "Patient.MiddleInitial",
  // ENG-2493 (D10): offered only in the extended Order menu, so every other picker is unchanged.
  MiddleName: "Patient.MiddleName",
  PreferredName: "Patient.PreferredName",
  Title: "Patient.Title",
  Suffix: "Patient.Suffix",
  SunoId: "Patient.SunoId"
};
